import axios from 'axios'
axios.defaults.withCredentials = false
import qs from 'qs' //query传参方式
import {
    createApp
} from 'vue';
import {
    Toast
} from 'vant';
const app = createApp();
app.use(Toast);
axios.defaults.timeout = 1000000;
// axios.defaults.baseURL = "https://pdxs.sdcskj.cn"
// axios.defaults.baseURL = "../"
// axios.defaults.baseURL = "http://192.168.31.36:805"

axios.defaults.baseURL = ""
// axios.defaults.baseURL = "http://ytwyw.cn"
// axios.defaults.baseURL = ""
    //请求拦截器
axios.interceptors.request.use(function(config) {
    // Toast.loading({
    //     duration: 0, // 持续展示 toast
    //     message: '加载中...',
    //     forbidClick: true,
    // });
    // console.log(config.url,'1111111111111111111111')
    var configUrl = config.url
    var configLast = configUrl.substring(configUrl.lastIndexOf("/") + 1);
    if (configLast == 'getRegionListByKeyWord') {
        Toast.clear();
    } else {
        Toast.loading({
            duration: 0, // 持续展示 toast
            message: '加载中...',
            forbidClick: true,
        });
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function postQuery(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(data))
            .then(response => {
                Toast.clear();
                resolve(response.data, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
            }, err => {
                Toast.clear();
                reject(err)
            })
    })
}
export function postJson(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                resolve(response.data);
                Toast.clear();
            }, err => {
                reject(err)
                Toast.clear();
            })
    })
}